import React from "react";
import ReportFilterMenu from "../Reports/Timps/reportFilterMenu";

import { ReportSelectorTable } from "../../CommonUI/ReportSelectorTable/ReportSelectorTable";
import Icon from "react-icons-kit";
import { ic_check } from "react-icons-kit/md/ic_check";
import { languageService } from "../../Language/language.service";
import { ButtonActionsTable } from "../Common/Buttons";
import { themeService } from "../../theme/service/activeTheme.service";
import { trackReportStyle } from "../Reports/Timps/style";
import InputDateField from "../Reports/Timps/inputdateField";
import { SelectField, SearchableSelectField } from "../Reports/Timps/reportfilter";
import { dataFormatters } from "../../utils/dataFormatters";
import moment from "moment";

const RenderDataReportsList = ({ state, actions }) => {
  const dailyInspectionListCols = [
    {
      id: "consistNumber",
      text: "Consist Number",
    },

    {
      id: "assets",
      text: "Asset",
      accessor: (d) => {
        const seenIds = new Set();
        return d.assets
          .sort((a, b) => a.order - b.order)
          .filter((asset) => {
            if (seenIds.has(asset.id)) return false;
            seenIds.add(asset.id);
            return true;
          })
          .map((asset) => asset.name)
          .join(", ");
      },
    },
    {
      id: "lineName",
      text: "Location",
    },
    {
      id: "action",
      text: "Action",
      accessor: (d) => {
        if (d.inspected)
          return (
            <ButtonActionsTable
              handleClick={(e) => {
                actions.handleClick(d, "D0");
              }}
              margin="0px 10px 0px 0px"
              buttonText={languageService("View")}
            />
          );
        else {
          return languageService("Not Available");
        }
      },
    },
  ];
  const LocomotiveInspectionListCols = [
    {
      id: "date",
      text: "Date",
      accessor: (d) => moment(d.date).format("MM/DD/YYYY"),
    },
    {
      id: "consistNumber",
      text: "Consist Number",
    },
    {
      id: "assets",
      text: "Asset",
      accessor: (d) => {
        const seenIds = new Set();
        return d.assets
          .sort((a, b) => a.order - b.order)
          .filter((asset) => {
            if (seenIds.has(asset.id)) return false;
            seenIds.add(asset.id);
            return true;
          })
          .map((asset) => asset.name)
          .join(", ");
      },
    },
    {
      id: "lineName",
      text: "Location",
    },
    {
      id: "action",
      text: "Action",
      accessor: (d) => {
        if (d.inspected)
          return (
            <ButtonActionsTable
              handleClick={(e) => {
                actions.handleClick(d, "D1");
              }}
              margin="0px 10px 0px 0px"
              buttonText={languageService("View")}
            />
          );
        else {
          return languageService("Not Available");
        }
      },
    },
  ];
  return (
    <div className="mainContent" style={{ textAlign: "center" }}>
      <ReportFilterMenu
        reports={state.reportTypes}
        activeReportId={state.selectedReport && state.selectedReport.reportId}
        handelTabsClick={actions.handleTabsClick}
      />
      <h2 style={{ ...themeService(trackReportStyle.headingStyle), transform: "none", fontSize: "22px" }}>
        {languageService(state.selectedReport.title)}
      </h2>
      {state.selectedReport && state.selectedReport.reportId === "D0" && (
        <React.Fragment>
          <ReportFilters state={state} actions={actions} dateRangeTitle={"Select Day"} noRange={true} />
          <ReportSelectorTable cols={dailyInspectionListCols} data={state.report1RowsList} />
        </React.Fragment>
      )}
      {state.selectedReport && state.selectedReport.reportId === "D1" && (
        <div className="mainContent commonform" style={{ ...themeService(trackReportStyle.mainStyle), background: "transparent" }}>
          <React.Fragment>
            <ReportFilters state={state} actions={actions} dateRangeTitle={"Select Date Range"} />

            {state.assetOptions && state.assetOptions.length > 0 && state.selectedAssetOption && (
              <SearchableSelectField
                inputFieldProps={{ name: "asset", label: "Assets" }}
                options={state.assetOptions}
                changeHandler={state.assetChangeHandler}
                value={state.selectedAssetOption.val}
              />
            )}
            <ReportSelectorTable cols={LocomotiveInspectionListCols} data={state.report2RowsList} />
          </React.Fragment>
        </div>
      )}
    </div>
  );
};
export default RenderDataReportsList;

const ReportFilters = ({ state, actions, dateRangeTitle, noRange }) => {
  return (
    <div className="report-filter">
      <label style={themeService(trackReportStyle.labelStyle)}>{languageService(dateRangeTitle)}</label>
      <span style={{ ...themeService(trackReportStyle.dateStyle), cursor: "pointer" }}>
        <InputDateField
          disabledDays={state.reportMinStartDate ? { before: new Date(state.reportMinStartDate) } : null}
          minReportDate={state.reportMinStartDate}
          updateDateRange={actions.updateDateRange}
          defaultDate={state.dateRange}
          noRange={noRange}
        />
      </span>
    </div>
  );
};

function checkIcon(report) {
  let icon = null;
  if (report && report.inspected) {
    icon = <Icon size={18} icon={ic_check} />;
  }
  return icon;
}



// WEBPACK FOOTER //
// ./src/components/ReVAMPDailyInpectionReports/RenderDataReportsList.jsx